(function () {
  // FAQ Accordion
  document.querySelectorAll('.vl-faq__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = this.closest('.vl-faq__item');
      var isOpen = item.classList.contains('is-open');

      // Close all
      document.querySelectorAll('.vl-faq__item').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('.vl-faq__trigger').setAttribute('aria-expanded', 'false');
      });

      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();
